import { LinesHelper } from "./LinesHelper";

export class ScheduleSetsHelper {
    static initializeMergedScheduleSetLine(set) {
        return {
            line: set.line,
            sets: [set]
        };
    }

    static initializeMergedScheduleSet(set) {
        return {
            first: this.initializeMergedScheduleSetLine(set),
            second: undefined
        };
    }

    static setLineMatch(set, mergedSet) {
        return undefined !== mergedSet && mergedSet.line === set.line;
    }

    static mergeScheduleSet(mergedScheduleSets, set) {
        // No elements (add first)
        if (0 === mergedScheduleSets.length) {
            mergedScheduleSets.push(this.initializeMergedScheduleSet(set));
            return;
        }

        // Set line not found (add line)
        const mergedSet = mergedScheduleSets.find(mergedSet => this.setLineMatch(set, mergedSet.first) || this.setLineMatch(set, mergedSet.second));
        if (undefined === mergedSet) {
            const lastMergedSet = mergedScheduleSets.slice(-1)[0];
            if (undefined === lastMergedSet.second) {
                lastMergedSet.second = this.initializeMergedScheduleSetLine(set)
                return;
            }

            mergedScheduleSets.push(this.initializeMergedScheduleSet(set));
            return;
        }

        if (this.setLineMatch(set, mergedSet.first)) {
            mergedSet.first.sets.push(set);
            return;
        }

        mergedSet.second.sets.push(set);
    }

    static mergeScheduleSets(sets) {
        if (undefined === sets || !Array.isArray(sets)) {
            return [];
        }

        const output = [];
        sets.forEach(set => this.mergeScheduleSet(output, set));

        return output;
    }

    static getLineName(set) {
        if(undefined === set || null === set) {
            return LinesHelper.getName();
        }

        return LinesHelper.getName(set.line);
    }

    static getLineShortName(set) {
        if(undefined === set || null === set) {
            return LinesHelper.getShortName();
        }

        return LinesHelper.getShortName(set.line);
    }
}
